app = angular.module('harriApp');

app.directive('likeDislike', ["$rootScope", function ($rootScope) {
  return {
    templateUrl: "../modules/client_portal/views/partials/like-dislike.html",
    restrict: 'E',
    scope: {
      'clientPortalId': '=clientPortalId',
      'userId': '=userId',
      'like': '=like',
      'previewMode':'=previewMode'
    },
    replace: true,
    link: function (scope) {
      
      var lock=false;
      scope.likeCandidate = function ($event,likeStatus) {
        if( lock ) return;
        lock = true;
        var preLike = scope.like;
        if(scope.previewMode){
          return;
        }
        var _el = angular.element($event.currentTarget);
        _el.parent().find('>a.btn').removeClass('active-state');

        var likeToSend = likeStatus;
        if(likeStatus == 1){
          likeToSend = (preLike == 1)?0:1;
          ClientPortalAPI.updateCandidateLikeStatus(scope.clientPortalId, likeToSend).then(function(){
            lock=false;
          });
        }else{
          likeToSend = (preLike == -1)?0:-1;
          ClientPortalAPI.updateCandidateLikeStatus(scope.clientPortalId, likeToSend).then(function(){
            lock=false;
          });;
        }

        /* update saved like */
        scope.like = likeToSend;
        if(likeToSend || likeToSend == -1){
          _el.addClass('active-state');
        }

        /* broadcast like event to listeners */
        $rootScope.$broadcast('candidate.like',scope.clientPortalId,preLike,likeToSend);
      }
    }
  }
}]);
